import * as yup from "yup";

export const updateStationaryCombustionValidation = yup.object({
  facility: yup.string().required("Facility is required"),
  month: yup.string().required("Month is required"),
  year: yup.string().required("Year is required"),
  emissionType: yup.string().required("Emission Type is required"),
  fuel: yup.string().required("Fuel is required"),
  fuelUnit: yup.string().required("Fuel unit is required"),
  amountOfFuel: yup
    .number()
    .typeError("Amount of fuel must be a valid number")
    .required("Amount of fuel is required"),
});
